// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nLNK7{width:100%}._2Ejnq{color:#3f9fff;font-weight:400;text-decoration:underline}", ""]);
// Exports
exports.locals = {
	"root": "nLNK7",
	"email": "_2Ejnq"
};
module.exports = exports;
